import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { ReportsService } from 'app/modules/admin/transactions/inwards/reports.service';
import { AlertMessageService } from 'app/core/common/alert.message.service';
import { BaseRespone } from 'app/core/models/common.response';
import { Observable, of, Subject } from 'rxjs';
import { DocumentMeasurementsService } from './document-measurement.service';
import { DocumentMeasurement } from './document-measurement.types';
import { filter, map, take, takeUntil } from 'rxjs/operators';
import { InwardReport } from 'app/modules/admin/transactions/inwards/reports.types';
import { SelectionModel } from '@angular/cdk/collections';
import { result } from 'lodash';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-document-measurement',
    templateUrl: './document-measurement.component.html',
    styleUrls: ['./document-measurement.component.scss']
})
export class DocumentMeasurementComponent implements OnInit {
    @Output("calculationAreas") calculationAreas: EventEmitter<any> = new EventEmitter();
    selection = new SelectionModel<DocumentMeasurement>(true, []);
    @Input() report: InwardReport;
    @Input() reportId: number;
    @Input() reportType: string;

    totalCarpet: number = 0.00;
    totalBuiltUp: number = 0.00;
    totalSuperBuiltUp: number = 0.00;
    selectedIds: number[] = [];
    selectedDocumentMeasurement: DocumentMeasurement;
    documentMeasurements$: Observable<DocumentMeasurement[]>;
    documentMeasurementForm: FormGroup;
    editingOrderIndex: number;
    documentMeasurement: DocumentMeasurement;
    alert: any;

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    constructor(private _matDialog: MatDialog,
        private _fuseConfirmationService: FuseConfirmationService,
        private _documentMeasurementService: DocumentMeasurementsService,
        private _alertMessageService: AlertMessageService,
        private _formBuilder: FormBuilder,
        private cdr: ChangeDetectorRef
    ) { }

    isAllSelectedCheckBox: boolean = false

    ngOnInit(): void {

        this.createDocumentForm();
        this._documentMeasurementService.getDocumentMeasurements(this.reportId).subscribe((res) => {
            this.calculateDocumentMeasurementsTotal();
        });

        this.documentMeasurements$ = this._documentMeasurementService.documentMeasurements$.pipe(
            map((data) => {
                data?.sort((a, b) => a.orderIndex - b.orderIndex);
                return data;
            })
        );
        // Get the contact
        this._documentMeasurementService.documentMeasurement$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((contact: DocumentMeasurement) => {

                // Update the selected contact

                this.selectedDocumentMeasurement = contact;

                // Mark for check
                //this._changeDetectorRef.markForCheck();
            });

    }
    createDocumentForm(): void {

        this.documentMeasurementForm = this._formBuilder.group({
            id: [''],
            reportId: this.reportId,
            flatPlotNo: ['', [Validators.required]],
            carpetArea: ['', [Validators.pattern(/^\d*(?:[.,]\d{1,2})?$/)]],
            builtUpArea: [''],
            superBuiltUpArea: ['0.0'],
            orderIndex: [''],
        });

    }

    new(): void {
        this._documentMeasurementService.addNewMeasurement(this.reportId);
    }

    cancelNewRow(index: number) {
        this._documentMeasurementService.cancelDocumentRow(index);
    }

    save(model: DocumentMeasurement) {
        if (!model.flatPlotNo || model.flatPlotNo.trim() === '') {
            // this._alertMessageService.error("Please flat/Unit No");
            this.alert = {
                type: 'error',
                message: 'Please flat/Unit No'
            };
            return;
        }

        if (model.id !== null && model.id !== 0) {
            this._documentMeasurementService.updateDocumentMeasurement(model).subscribe((response) => {
                if (response.isSuccess) {
                    // Show a success message...
                    this.alert = {
                        type: 'success',
                        message: 'Document Measurement updated successfully!'
                    };
                }
                else {
                    this._alertMessageService.error(response.errors.join("\n"));
                }
            });
        } else {
            this._documentMeasurementService.createDocumentMeasurement(model).subscribe((response) => {
                if (response.isSuccess) {
                    this.alert = {
                        type: 'success',
                        message: 'Document measurement added successfully'
                    };
                }
                else {
                    this._alertMessageService.error(response.errors.join("\n"));
                }
            });
        }
    }


    /** 
    * Delete the selected product using the form data
    */
    delete(id: number): void {
        const confirmation = this._fuseConfirmationService.open({
            title: 'Delete Document Measurement',
            message: 'Are you sure you want to remove? This action cannot be undone!',
            actions: {
                confirm: {
                    label: 'Delete'
                }
            }
        });

        confirmation.afterClosed().subscribe((result) => {

            if (result === 'confirmed') {

                this._documentMeasurementService.deleteDocumentMeasurement(id).subscribe((res) => {
                    if (res.isSuccess) {
                        this.alert = {
                            type: 'success',
                            message: 'Document measurement deleted successfully'
                        };
                        this.documentMeasurements$.pipe(take(1)).subscribe(data => {
                            if (data) {
                                this.updateOrderIndex(data);
                            }
                        });
                    }
                    else {
                        this._alertMessageService.error(res.errors.join('\n'));
                    }
                });
            }
        });
    }

    async deleteSelectedRows() {
        const confirmation = this._fuseConfirmationService.open({
            title: 'Delete All Document Measurement',
            message: 'Are you sure you want to remove? This action cannot be undone!',
            actions: {
                confirm: {
                    label: 'Delete'
                }
            }
        });

        const result = await confirmation.afterClosed().toPromise();

        if (result === 'confirmed') {
            const ids = this.selection.selected.map(item => item.id);
            const res = await this._documentMeasurementService.deleteAllDocumentMeasurement(ids).toPromise();

            if (res.isSuccess) {
                this.alert = {
                    type: 'success',
                    message: 'Document measurement all deleted successfully'
                };
                this.documentMeasurements$.pipe(take(1)).subscribe(data => {
                    if (data) {
                        this.updateOrderIndex(data);
                    }
                });
                this.selection.clear();
                this.documentMeasurements$.subscribe()
            } else {
                this.alert = {
                    type: 'error',
                    message: res.errors.join('\n')
                };
            }
        }
    }


    /**
    * Track by function for ngFor loops
    *
    * @param index
    * @param item
    */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    calculateDocumentMeasurementsTotal(): void {
        this._documentMeasurementService.documentMeasurements$.subscribe(res => {
            this.report.deedArea = Number(res.reduce((sum, current) => sum + current.carpetArea, 0).toFixed(2));
            this.report.deedBuiltUp = Number(res.reduce((sum, current) => sum + current.builtUpArea, 0).toFixed(2));
            this.report.deedSuperBuiltUp = Number(res.reduce((sum, current) => sum + current.superBuiltUpArea, 0).toFixed(2));
            this.calculationAreas.emit();
        });
    }

    updateCheckedList(event, row) {
        this.documentMeasurements$.pipe(take(1)).subscribe(measurements => {
            measurements.forEach(item => {
                if (item.id == row.id) {
                    item.selected = event.checked;
                    if (item.selected) {
                        this.selection.select(item); // Select item in selection model
                    }
                    else {
                        this.selection.deselect(item);
                    }
                }
            });
            this.isAllSelectedCheckBox = !measurements.some(a => !a.selected)
        });
    }

    selectAll(event: any) {
        const checked = event.checked;
        this.documentMeasurements$.pipe(take(1)).subscribe((measurements: any[]) => {
            measurements.forEach((measurement) => {
                measurement.selected = checked;
            });
        });
    }

    checkboxLabel() {
        if (this.isAllSelected()) {
            return 'Deselect all';
        }
        if (this.selection.isEmpty()) {
            return 'Select all';
        }
        return `${this.selection.selected.length} selected`;
    }

    isAllSelected() {
        // Check if all measurements are selected
        return this.documentMeasurements$.pipe(
            take(1),
            map(measurements => measurements.every(measurement => measurement.selected))
        );
    }

    toggleAllRows() {
        this.isAllSelected().subscribe(allSelected => {
            if (!allSelected) {
                // Select all items
                this.documentMeasurements$.pipe(take(1)).subscribe(measurements => {
                    measurements.forEach(item => {
                        item.selected = true;
                        this.selection.select(item); // Select item in selection model
                    });
                });
                this.isAllSelectedCheckBox = true;
            } else {
                // Deselect all items
                this.documentMeasurements$.pipe(take(1)).subscribe(measurements => {
                    measurements.forEach(item => {
                        item.selected = false;
                        this.selection.deselect(item); // Deselect item in selection model
                    });
                });
                this.isAllSelectedCheckBox = false;
            }
        });
    }
    // calculateDocumentMeasurementsTotal(): void {
    //     this._documentMeasurementService.documentMeasurements$.subscribe(res => {
    //         this.report.deedArea = res.reduce((sum, current) => sum + current.carpetArea, 0);
    //         this.report.deedBuiltUp = res.reduce((sum, current) => sum + current.builtUpArea, 0);
    //         this.report.deedSuperBuiltUp = res.reduce((sum, current) => sum + current.superBuiltUpArea, 0);
    //         this.calculationAreas.emit();
    //     })
    // }

    drop(event: CdkDragDrop<DocumentMeasurement[]>): void {
        // Retrieve current data from the observable
        this.documentMeasurements$.pipe(take(1)).subscribe((data) => {
            if (data) {
                // Reorder locally
                moveItemInArray(data, event.previousIndex, event.currentIndex);
                this.updateOrderIndex(data);
            }
        });
    }

    updateOrderIndex(data: DocumentMeasurement[]): void {
        data.forEach((item, index) => {
            item.orderIndex = index + 1; // Reset order index

            if (item.id > 0) {
                // Only update items that are already saved (id > 0)
                this._documentMeasurementService.updateDocumentMeasurement(item).subscribe();
            }
        });
    }

    originalValues = new Map<string, any>();

    getKey(documentMeasurement: any, field: string): string {
        return (documentMeasurement.id ?? documentMeasurement.tempId ?? JSON.stringify(documentMeasurement)) + '_' + field;
    }

    // Called when field is focused to store the original value
    onInputInit(documentMeasurement: any, field: string) {
        const key = this.getKey(documentMeasurement, field);
        if (!this.originalValues.has(key)) {
            this.originalValues.set(key, this.cloneValue(documentMeasurement[field]));
        }
    }

    // Called on each value change
    onFieldChange(documentMeasurement: any, field: string) {
        const key = this.getKey(documentMeasurement, field);
        const original = this.originalValues.get(key);
        const current = documentMeasurement[field];

        if (!this.deepEqual(original, current)) {
            this.save(documentMeasurement); // auto-save logic
            this.originalValues.set(key, this.cloneValue(current)); // update cache
        }
    }

    // Utility: deep compare for objects/arrays/primitives
    deepEqual(a: any, b: any): boolean {
        return JSON.stringify(a) === JSON.stringify(b);
    }

    // Utility: clone value (for caching original values safely)
    cloneValue(val: any): any {
        return JSON.parse(JSON.stringify(val));
    }
}
